import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, FileText, Users, LogOut, ExternalLink } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const items = [
  { to: "/admin", label: "Tableau de bord", icon: LayoutDashboard, end: true, testid: "admin-nav-dashboard" },
  { to: "/admin/articles", label: "Décryptages", icon: FileText, testid: "admin-nav-articles" },
  { to: "/admin/subscribers", label: "Abonnés", icon: Users, testid: "admin-nav-subscribers" },
];

export default function AdminLayout() {
  const { logout, user } = useAuth();
  const navigate = useNavigate();

  const doLogout = () => {
    logout();
    navigate("/admin/login", { replace: true });
  };

  return (
    <div className="flex min-h-screen flex-col bg-bz-ivory md:flex-row">
      <meta name="robots" content="noindex, nofollow" />
      <aside className="flex shrink-0 flex-col border-b border-bz-line bg-white md:w-64 md:border-b-0 md:border-r">
        <div className="border-b border-bz-line px-6 py-6">
          <span className="font-serif text-xl tracking-[0.24em] text-bz-navy">BENZENATI</span>
          <p className="mt-1 text-[0.6rem] uppercase tracking-[0.22em] text-bz-slate">Administration</p>
        </div>
        <nav className="flex flex-1 flex-col gap-1 px-3 py-4">
          {items.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              end={it.end}
              data-testid={it.testid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-3 text-sm transition-colors ${
                  isActive ? "bg-bz-navy text-bz-ivory" : "text-bz-slate hover:bg-bz-ivory2 hover:text-bz-navy"
                }`
              }
            >
              <it.icon size={18} strokeWidth={1.5} /> {it.label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-bz-line px-3 py-4">
          <a href="/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 px-3 py-2 text-sm text-bz-slate hover:text-bz-navy">
            <ExternalLink size={18} strokeWidth={1.5} /> Voir le site
          </a>
          <button onClick={doLogout} data-testid="admin-logout" className="flex w-full items-center gap-3 px-3 py-2 text-sm text-bz-slate hover:text-bz-navy">
            <LogOut size={18} strokeWidth={1.5} /> Déconnexion
          </button>
          {user?.email && <p className="mt-3 px-3 text-xs text-bz-slate/60">{user.email}</p>}
        </div>
      </aside>

      <main className="flex-1 overflow-x-hidden px-6 py-10 lg:px-12">
        <Outlet />
      </main>
    </div>
  );
}
